import './root/initDatadogLogs';
import './root/initDatadogRum';

import { createRoot } from 'react-dom/client';

import { App } from './root';
import { register as registerServiceWorker } from './service-worker/registration';

async function prepareApp() {
  if (
    process.env.NODE_ENV !== 'production' &&
    import.meta.env.VITE_MOCK_SERVICE_WORKER_ENABLED === 'true'
  ) {
    const { worker } = await import('./browserMock');
    return worker.start({
      onUnhandledRequest: 'bypass',
    });
  }
  return Promise.resolve();
}

async function runApp() {
  await prepareApp();
  const container = document.getElementById('root')!;
  const root = createRoot(container);
  root.render(<App />);
}

void runApp();

// only registers in production
registerServiceWorker();
